import React from "react";
import { Box } from "@mui/material";

interface ThumbnailGridProps {
  // Minimum column width in px; columns auto-fill responsively across the available width.
  minWidth: number;
  // Space between cells, in MUI spacing units (1 = 8px). Defaults to a small gutter.
  gap?: number;
  children: React.ReactNode;
}

// The one layout every thumbnail gallery uses: a responsive grid of uniform cells. Plain CSS grid
// through the MUI Box, so it wraps and gutters cleanly with no row-height juggling.
const ThumbnailGrid: React.FC<ThumbnailGridProps> = ({ minWidth, gap = 1, children }) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: `repeat(auto-fill, minmax(${minWidth}px, 1fr))`,
      gap,
      justifyItems: "center",
      alignContent: "start",
    }}
  >
    {children}
  </Box>
);

export default ThumbnailGrid;
